// extracted by mini-css-extract-plugin
export default {"container":"style_container__zOFkl","actionIcon":"style_actionIcon__3vdXD","emptyRow":"style_emptyRow__fL+Wb","textNew":"style_textNew__YYPK2","tag":"style_tag__97wLt"};